<template>
  <div class="module-locked">
    <div class="icon">
      {{ icon }}
    </div>

    <div class="content">
      <h3>{{ title }}</h3>
      <p>{{ message }}</p>

      <small v-if="hint">{{ hint }}</small>
    </div>

    <!-- <div v-if="actionText" class="action">
      <button @click="$emit('action')" class="btn">
        {{ actionText }}
      </button>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'ModuleLocked',
  props: {
    module: { type: String, default: '' },
    title: { type: String, default: 'Modul indisponibil' },
    message: { type: String, required: true },
    hint: { type: String, default: '' },
    icon: { type: String, default: '🔒' },
    actionText: { type: String, default: '' }
  }
}
</script>

<style scoped>
.module-locked {
  display: flex;
  align-items: center;
  gap: 16px;

  padding: 18px 20px;
  border-radius: 14px;

  background: #674BD2;
  color: #fff;

  border: 1px solid rgba(255,255,255,0.08);
  box-shadow: 0 10px 30px rgba(0,0,0,0.25);
}

.icon {
  font-size: 28px;
  width: 50px;
  height: 50px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(255,255,255,0.08);
  border-radius: 12px;
}

.content h3 {
  margin: 0;
  font-size: 16px;
}

.content p {
  margin: 4px 0;
  opacity: 1;
}

.content small {
  opacity: 1;
  color: #fff !important;
}

.btn {
  background: #f97316;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 8px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/ModuleLocked.vue